module.exports = __webpack_public_path__ + "img/instagram.7659b813.svg";